// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QMbD","label":"styles_label__2GcNP"};